import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';

import { LastOwnedCardsByPlayer } from '#src/components/player/LastOwnedCardsByPlayer/index.tsx';
import { SearchTableFirstCell } from '#src/components/searchPlayerTable/SearchTable/ui.tsx';

import { AnyStatsIconCell } from './AnyStatsIconCell/index.tsx';
import { CommonPlayerMetas } from './CommonPlayerMetas/index.tsx';
import { SearchPlayerCellActions } from './SearchPlayerCellActions/index.tsx';
import type { SearchPlayerCell_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  anyPlayer: SearchPlayerCell_anyPlayer;
  onStatsClick: () => void;
  watchlistId?: string;
  favoritesWatchlist?: boolean;
};

const TopLeftPosition = styled.div`
  z-index: 10;
  position: absolute;
  top: var(--unit);
  left: var(--unit);
`;

export const SearchPlayerCell = ({
  anyPlayer,
  onStatsClick,
  watchlistId,
  favoritesWatchlist,
}: Props) => {
  const { up: upLaptopOrAbove } = useScreenSize('laptop');
  return (
    <SearchTableFirstCell>
      {!!upLaptopOrAbove && (
        <TopLeftPosition>
          <LastOwnedCardsByPlayer anyPlayer={anyPlayer} />
        </TopLeftPosition>
      )}
      {!!upLaptopOrAbove && (
        <SearchPlayerCellActions
          anyPlayer={anyPlayer}
          watchlistId={watchlistId}
          favoritesWatchlist={favoritesWatchlist}
        />
      )}
      <CommonPlayerMetas anyPlayer={anyPlayer} onStatsClick={onStatsClick} />
      <AnyStatsIconCell anyPlayer={anyPlayer} onStatsClick={onStatsClick} />
    </SearchTableFirstCell>
  );
};

SearchPlayerCell.fragments = {
  anyPlayer: gql`
    fragment SearchPlayerCell_anyPlayer on AnyPlayerInterface {
      slug
      ...CommonPlayerMetas_anyPlayer
      ...AnyStatsIconCell_anyPlayer
      ...LastOwnedCards_anyPlayer
      ...SearchPlayerCellActions_anyPlayer
    }
    ${CommonPlayerMetas.fragments.anyPlayer}
    ${AnyStatsIconCell.fragments.anyPlayer}
    ${LastOwnedCardsByPlayer.fragments.anyPlayer}
    ${SearchPlayerCellActions.fragments.anyPlayer}
  ` as TypedDocumentNode<SearchPlayerCell_anyPlayer>,
};
